'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);
var domCache = require('dom-cache');

var lookForRecaptchaDivs = function() {

	var $recaptchaDivs = domCache.document.find('.g-recaptcha');

	if ($recaptchaDivs.length) {
		var $form = $recaptchaDivs.parents('form');

		$form.on('submit', onRecaptchaFormSubmitted);
	}

};

var setupRecaptcha = function() {

	window.grecaptcha.render(domCache.document.find('.g-recaptcha')[0], {
		'callback': window.pbizCorporate.recaptcha.executeRecaptchaCallback
	});

};

var executeRecaptchaCallback = function() {

	console.log('executeRecaptchaCallback...', arguments);

	domCache.document.find('.g-recaptcha').parents('form').submit();

};

var init = function() {

	window.executeRecaptchaCallback = executeRecaptchaCallback;

};

module.exports = {
	init: init,
	executeRecaptchaCallback: executeRecaptchaCallback,
	setupRecaptcha: setupRecaptcha
};
